import { render, staticRenderFns } from "./MemoList.vue?vue&type=template&id=68bc49c1&scoped=true&"
import script from "./MemoList.vue?vue&type=script&lang=js&"
export * from "./MemoList.vue?vue&type=script&lang=js&"
import style0 from "./MemoList.vue?vue&type=style&index=0&id=68bc49c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bc49c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDialog,VRow,VSimpleTable,VSpacer})
